import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import cell from '../../assets/img/cellbank/cellbank1.jpg'
import mobile from '../../assets/img/cellbank/l_mobile.png'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import Header from '../Header'
import time from '../../assets/img/icon/all-white.png'
import cb_1 from '../../assets/img/gif/cb_1.gif'
import cb_2 from '../../assets/img/gif/cb_2.gif'
import cb_3 from '../../assets/img/gif/cb_3.gif'
import cb_4 from '../../assets/img/gif/cb_4.gif'
import logo from '../../assets/img/logo-white.png'
import share from '../../assets/img/icon/share.png'
import cb_d_1 from '../../assets/img/cellbank/cb_d_1.png'
import cb_d_2 from '../../assets/img/cellbank/cb_d_2.png'
import cb_d_3 from '../../assets/img/cellbank/cb_d_3.png'
import cb_d_4 from '../../assets/img/cellbank/cb_d_4.png'
import cb_d_5 from '../../assets/img/cellbank/cb_d_5.png'
import intro from '../../assets/img/cellbank/cellbank_banner.jpg'
import QASectionSub from '../../components/sections/QASectionSub'
import { InfoSection } from '../../components/InfoSection'
import { services } from '../../assets/dummy'
import DownloadSection from '../../components/DownloadSection'
import ServiceModal from '../../components/ServiceCardModal'
import ServiceCardNew from '../../components/ServiceCard'
import carepay from '../../assets/img/carepay/carepay_bg.png'
import android from '../../assets/img/carepay/android.png'
import apple from '../../assets/img/carepay/apple.png'

const data4 = [
  {
    id: 1,
    img: cb_1,
    title: 'Ирээдүйн эмчилгээний боломж',
    desc: 'Үүдэл эсийг хадгалснаар цусны хорт хавдар, дархлааны эмгэг, зүрх судасны өвчин, мэдрэлийн өвчин зэрэг олон өвчнийг эмчлэхэд ашиглах боломжтой болох бөгөөд тухайн хүнд онцгой зохицсон, үр дүнтэй эмчилгээ хийх нөхцөлийг бүрдүүлнэ.'
  },
  {
    id: 2,
    img: cb_2,
    title: 'Гэр бүлийн эрүүл мэндийг хамгаалах',
    desc: 'Хүйн цус, хүйн эдийн үүдэл эс нь гэр бүлийн бусад гишүүдэд ч тохирох магадлалтай байдаг тул гэр бүлийн эрүүл мэндийн чухал нөөц болж чадна.'
  },
  {
    id: 3,
    img: cb_3,
    title: 'Хөгшрөлтийн эрсдэлийг бууруулах',
    desc: 'Хүний нас ахих тусам үүдэл эсүүд хөгширч, тоо хэмжээ нь багасаж, чадамж нь буурдаг бол төрөх үед хадгалуулсан эс нь нөхөн төлжих чадвараа хадгалсан байдаг тул хөгшрөлтийн эсрэг болон гоо сайхны эмчилгээнд онцгой үр дүнтэй ашиглагддаг.'
  },
  {
    id: 3,
    img: cb_4,
    title: 'Ховор, эмчилгээгүй өвчний эмчилгээ',
    desc: 'Ирээдүйд ховор өвчнийг эмчлэх цорын ганц боломж үүдэл эс байх магадлалтай бөгөөд шинэ эмчилгээ, технологийн хөгжил эсийн хадгалалтаас хамаарах учир урьдчилан бэлтгэх нь эрүүл мэндээ хамгаалах ухаалаг хөрөнгө оруулалт болно.'
  }
]
export default function Cellbank () {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedService, setSelectedService] = useState(null)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50) 
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (window.FB) {
      window.FB.XFBML.parse()
    }
  }, [])
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const filteredServices = services.filter(
    service => service.tag === 'Эсийн банк'
  )
  const shareOnFacebook = () => {
    const url = 'https://cellclinic.mn'
    const appId = '269289457116917' // Your Facebook App ID
    const shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}&app_id=${appId}`
    window.open(shareURL, '_blank')
  }

  const openModal = service => {
    setSelectedService(service)
    setIsModalOpen(true)
  }

  // Close Modal Function
  const closeModal = () => {
    setSelectedService(null)
    setIsModalOpen(false)
  }

  return (
    <>
      <Helmet>
        <title>CellClinic - Эсийн банк</title>
        <meta property='og:title' content='CellClinic - Эсийн банк' />
        <meta
          property='og:description'
          content='Хүйн цус болон хүйн эд нь үүдэл эсийн хосгүй эх үүсвэр бөгөөд эдгээр эсүүдийг ирээдүйд төрөл бүрийн өвчнийг эмчлэхэд ашиглах боломжтой.'
        />
        <meta
          property='og:image'
          content='http://localhost:3088/static/media/cb_d_1.09d13f72574aa238d3c5.png'
        />
        <meta property='og:url' content='https://cellclinic.mn' />
        <meta property='og:type' content='website' />
        <meta property='fb:app_id' content='269289457116917' />
      </Helmet>

      <div className=' bg-gradient-to-l from-[#89E5D6] to-[#08393C] h-[100vh] '>
        <div
          className='bg-gradient-to-l from-[#89D4E5] to-[#08273C] bg-cover bg-center bg-no-repeat h-[100vh]'
          style={{
            backgroundImage: isMobile ? '' : `url(${cell})`
            // mixBlendMode: 'luminosity'
          }}
        >
          <div
            className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full  z-50 transition-all duration-300 ${
              isScrolled
                ? 'bg-blue shadow-md h-[7vh] top-1 max-w-[1440px] extraScreen:max-w-[1500px]'
                : 'bg-transparent h-[5vh]'
            }`}
          >
            <Header
              color={isScrolled ? 'black' : 'white'}
              gradientColor={isScrolled ? 'bg-white/90' : 'bg-none'}
            />
          </div>
          {/* <Header color='white' gradientColor='' /> */}
          <div
            className='flex-1 h-[90vh] flex flex-row items-center justify-center gap-5 p-20 mobile:gap-0 mobile:p-8 mobile:flex-col tablet:flex-col tablet:py-2 tablet:px-5  maxScreen:max-w-[1440px] extraScreen:max-w-[1660px] 
                      maxScreen:mx-auto extraScreen:mx-auto '
          >
            <div className='w-1/2 mobile:w-full tablet:w-full mobile:h-1/2 tablet:h-1/2 tablet:flex tablet:justify-center tablet:flex-col mobile:mt-20'>
              <button className='backdrop-blur-xl bg-white/10 py-1.5 px-5 text-white rounded-xl mt-5 flex items-center justify-center gap-2 cursor-pointer text-xs mobile:mb-2 mobile:px-4 tablet:w-[160px] mobile:hidden'>
                <img src={time} alt='ds' className='w-6 h-6' />
                Эсийн банк
              </button>
              <p className='text-[57px] mobile:text-[24px] text-white font-bold mobile:text-start mobile:mt-0 tablet:text-[36px] tablet:w-[437px]'>
                Эсийг хадгална
              </p>
              <p
                className='text-[18px] mt-10 w-[400px] text-left text-white/70 font-normal mobile:mt-5 mobile:w-full mobile:text-justify
            mobile:text-[16px] tablet:text-[18px] tablet:w-full tablet:mt-5'
              >
                Хүйн цус болон хүйн эд нь үүдэл эсийн хосгүй эх үүсвэр бөгөөд
                эдгээр эсүүдийг ирээдүйд төрөл бүрийн өвчнийг эмчлэхэд ашиглах
                боломжтой. Манай эмнэлэг хүйн цус болон хүйн эдээс үүдэл
                эсийг өндөр технологиор ялган авч, олон жилийн туршид чанарын
                алдагдалгүй хадгалах нөхцөлийг бүрдүүлдэг.
                <button
                  onClick={() =>
                    shareOnFacebook(
                      'Эсийг хадгална',
                      'Хүйн цус болон хүйн эд нь үүдэл эсийн хосгүй эх үүсвэр бөгөөд эдгээр эсүүдийг ирээдүйд төрөл бүрийн өвчнийг эмчлэхэд ашиглах  боломжтой. Манай эмнэлэг хүйн цуснаас болон хүйн эдээс үүдэлэсийг өндөр технологиор ялган авч, олон жилийн туршид чанарын алдагдалгүй хадгалах нөхцөлийг бүрдүүлдэг.',
                      cell
                    )
                  }
                  // className='bg-blue-600 text-white p-3 rounded'
                >
                  <img src={share} className='h-5 w-5' alt='share'></img>
                </button>
                {/* <FBShareButton /> */}
              </p>
            </div>

            <div className='w-1/2 mobile:w-full tablet:w-full mobile:h-1/2 tablet:h-1/2 mobile:mt-[-100px] mobile:flex mobile:justify-center'>
              <div
                className='bg-center bg-no-repeat rounded-3xl w-full h-full hidden mobile:flex'
                style={{
                  backgroundImage: `url(${mobile})`,
                  backgroundSize: '100% 100%',
                  backgroundPosition: 'center'
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='px-0 maxScreen:px-20 extraScreen:px-20 maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'>
        <div
          className='flex flex-col justify-center items-center py-10 mobile:py-5 tablet:py-5 '
        >
          <p
            className='text-[#1B4046] text-[34px]  text-center font-inter-bold uppercase'
            style={{ lineHeight: 1.1 }}
          >
            Эсийн банкны үнэ цэнэ ба ирээдүйн боломжууд
          </p>
          <div
            className='grid grid-cols-4 gap-5 mt-10 px-20 mobile:grid-cols-1 tablet:grid-cols-2 mobile:mt-0 mobile:p-5 tablet:p-5 
        maxScreen:px-0 extraScreen:px-0
         maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto '
          >
            {data4.map(item => (
              <div className='bg-[#1B4046] w-fit p-5 rounded-xl border-[#78C6B9] border-4'>
                <div className='flex flex-row h-[60px] gap-2 justify-center items-center'>
                  <div className='backdrop-blur-xl bg-white/10 rounded-lg p-1.5 h-[50px] w-[70px] flex flex-col justify-center items-center'>
                    <img
                      src={item.img}
                      className='h-10 w-10'
                      alt={item.title}
                    />
                  </div>
                  <p className='text-[#84DECF] text-[16px] '>{item.title}</p>
                </div>
                <p className='text-[#70BEB1] text-[14px] mt-3'>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
        <div className='mx-20 mb-20 mobile:mx-5 mobile:mb-5 tablet:mx-5 tablet:mb-5 mobile:mt-[-20px]  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'>
          <div className='flex flex-col justify-center items-start p-10 bg-[#EBFCFF] mobile:p-5 tablet:p-5 rounded-2xl'>
            <button
              className='text-[#1B4046] text-[26px] font-inter-bold px-5  border-l-2 border-[#4EB5C6]  mb-5
             bg-gradient-to-l from-[#FFFFFF1F] to-[#72C5B91F]
            text-start 
          mobile:text-[24px] mobile:w-full tablet:w-full tablet:text-[30px] tablet:mb-4'
            >
              Таны хадгалуулсан хүйн цус, хүйн эдийн үүдэл эс нь танай гэр
              бүлийн өмч юм.
            </button>
            <InfoSection
              title='Эсийн банк гэж юу вэ?'
              text='Эсийн банк нь хүний биеийн эс, эд болон биологийн материалыг урт хугацаанд хадгалж, шаардлагатай үед ашиглах боломжийг бүрдүүлсэн дэвшилтэт технологитой байгууллага юм. Эдгээрийг -196°C хэмийн шингэн азотод хадгалснаар олон арван жилийн турш чанарыг нь алдагдуулахгүй хамгаалдаг. Орчин үед эсийн банкнууд хүйн цус, хүйн эдийн үүдэл эс, дархлааны эс, өндгөн эс, эр бэлгийн эс, үр хөврөл зэрэг биологийн үнэт материалуудыг хадгалж нөхөн сэргээх, дархлаа зохицуулга, нөхөн үржихүйн эмчилгээнд ашиглаж байна. '
              imgSrc={cb_d_1}
            />
            <InfoSection
              title='Үүдэл эс гэж юу вэ?'
              text='Үүдэл эс нь хүний биед шинэ эсүүдийг үүсгэх, гэмтсэн эдийг нөхөн сэргээх чадвартай анхдагч эс юм. Энэ эс нь олон төрлийн эд, эрхтний эс болон хувирч чаддаг тул анагаах ухаанд өндөр ач холбогдолтой.
Үүдэл эсийн хамгийн түгээмэл 2 төрөл байдаг
'
              list={[
                '• 	Цусны үүдэл эс – Дархлааны болон цусны эсүүдийг үүсгэнэ.',
                '• 	Мезенхимийн үүдэл эс – Яс, мөгөөрс, булчин, арьс, өөх, мэдрэлийн эс зэрэг олон төрлийн эдийг нөхөн төлжүүлнэ.'
              ]}
              imgSrc={cb_d_2}
              reverse
            />
            <button
              className='text-[#1B4046] px-5  border-l-2 border-[#4EB5C6] text-[26px] font-inter-bold mb-5
             bg-gradient-to-l from-[#FFFFFF1F] to-[#72C5B91F]
            text-start 
          mobile:text-[24px] mobile:w-full tablet:w-full tablet:text-[30px] tablet:mb-4'
            >
              Хүйн цус, хүйн эд нь залуу, эрүүл үүдэл эсийг хамгийн ихээр
              агуулдаг цорын ганц эх үүсвэр юм.
            </button>
            <div className='mb-5'></div>
            <InfoSection
              title='Үүдэл эсийг хэзээ авч хадгалах вэ?'
              text='Үүдэл эсийг авах хамгийн зөв цаг бол төрөх үе юм. Энэ мөчид эсүүд хамгийн залуу, эрүүл, биологийн өндөр идэвхтэй байдаг. Жишээ нь, нярайн мезенхимийн үүдэл эсийн тоо 6 тэрбум орчим байдаг бол 80 нас хүрэхэд ердөө 30-50 сая болж буурдаг. Зөвхөн тоо бус, нөхөн төлжих, дархлаа зохицуулах чадвар нь ч мөн сулрах хандлагатай..'
              list={[
                '• 	Хүйн цус ба ясны чөмөг хоёул цусны үүдэл эс агуулдаг ч, хүйн цусны эс ясны чөмгөний эсээс 30-250 дахин хурдан олширч чаддаг.',
                '• 	Хүйн эдээс гаргасан мезенхимийн үүдэл эс нь насанд хүрсэн хүний өөхөн эдээс гаргасантай харьцуулахад 1.5-3 дахин хурдан хуваагдаж, нөхөн төлжих чадвар нь илүү байдаг.',
                '• 	Насанд хүрсэн хүний үүдэл эсийг авахын тулд мэс ажилбар шаардлагатай бол, хүйн цус болон хүйн эдийг ихэс төрсний дараа эх, нярайд ямар ч эрсдэлгүйгээр цуглуулж, хадгалах боломжтой.'
              ]}
              imgSrc={cb_d_3}
            />
            <InfoSection
              title='Үүдэл эсийн эмчилгээний одоогийн хэрэглээ'
              list={[
                '• 	Хүйн цусны үүдэл эсийг олон улсад 80 гаруй өвчний эмчилгээнд ашиглаж байна. Үүнд цус, дархлааны тогтолцооны өвчнүүд (лейкеми, лимфома, миелома), ясны чөмөг шилжүүлэн суулгалтын дараах хүндрэлүүд багтдаг. Зарим улс оронд тархины саажилт, чонон хөрвөс, зүрхний шигдээс, чихрийн шижингийн эмчилгээнд туршиж байна.',
                '• 	Мезенхимийн үүдэл эсийг албан ёсоор остеоартрит (үе мөчний үрэвсэл), гэмтэлтэй эдийн нөхөн төлжилт, дархлааны эмгэгүүд (суулгац эзний эсрэг урвал, Кроны өвчин, шархлаат колит) зэрэгт хэрэглэдэг.',
                '• 	Зарим улс оронд үүдэл эсийг зүрхний шигдээс, зүрхний дутагдал, нугасны гэмтэл, тархины саажилт, Альцгеймерийн өвчин, элэгний хатуурал, чихрийн шижин, хүнд хэлбэрийн түлэгдэл, уушгины хатуурал, COVID-19-ийн хүндрэл зэргийн эмчилгээнд судалж, туршин хэрэглэж байна.'
              ]}
              imgSrc={cb_d_4}
              reverse
            />
            <button
              className='text-[#1B4046] px-5  border-l-2 border-[#4EB5C6] text-[26px] font-inter-bold mb-5 mt-5
             bg-gradient-to-l from-[#FFFFFF1F] to-[#72C5B91F]
            text-start 
          mobile:text-[24px] mobile:w-full tablet:w-full tablet:text-[30px] tablet:mb-4'
            >
              Монгол Улсад одоогоор хүйн цус, хүйн эдийн үүдэл эс хадгалах
              үйлчилгээ байхгүй тул эдгээр үнэт материалууд эмнэлгийн хог
              хаягдал болж устгагддаг.
            </button>
            <div className='mb-5'></div>
            <InfoSection
              title='Үүдэл эсийн эмчилгээний ирээдүйн боломж'
              text='Үүдэл эсийн судалгаа, хөгжүүлэлт нь анагаах ухааны хувьсгалын дараагийн томоохон чиглэл болж байна. Яг одоо хийгдэж байгаа ClinicalTrials.gov мэдээллийн сан дахь судалгаанууд:'
              list={[
                '• 	Хорт хавдрын шинэ эмчилгээ – Үүдэл эсийг ашиглан хавдрын эсрэг илүү үр дүнтэй, аюулгүй эмчилгээний аргуудыг хөгжүүлэх.',
                '• 	Эрхтэн нөхөн төлжилт – Бөөр, элэг, зүрх, уушги, мэдрэлийн систем, нугасны гэмтэл зэргийг эмчлэх шинэ боломжуудыг судлах.',
                '• 	Дархлаа болон халдварт өвчний эмчилгээ – Шинэ төрлийн вирус, аутоиммун өвчний эсрэг үүдэл эсийн хэрэглээг өргөжүүлэх.'
              ]}
              text2='Эдгээр судалгаанууд нь үүдэл эсийн эмчилгээний цар хүрээг тэлж, эмчлэгдэх боломжгүйд тооцогдож байсан олон өвчнийг бүрэн эдгээх шинэ гарц бий болгох өндөр магадлалтай. Ирээдүйд үүдэл эсийн технологи нь дэлхийн анагаах ухааны голлох эмчилгээний нэг болж, хүний амь насыг аврах, амьдралын чанарыг сайжруулах түлхүүр шийдэл болно.'
              imgSrc={cb_d_5}
            />
          </div>
        </div>
        <div className='relative z-10'>
          <DownloadSection
            image={intro}
            pdfLink='/pdf/CELLCLINIC_CELLBANK.pdf'
            gradient='linear-gradient(270deg, #89E5D6 0%, #08393C 40%)'
            subjectPassed='Эсийн эмчилгээний танилцуулга'
            text1='Танд хүйн цус, хүйн эдийн үүдэл эс хадгалуулах аяллын эхний алхмыг хийсэнд баяр хүргэе! 🎉'
            text2='Бид таны хүүхдийн үнэтэй нөөц болох хүйн цус болон хүйн эдийн үүдэл эсийг хадгалах шийдвэрийг илүү ойлгомжтой, хялбар болгоход туслахад үргэлж бэлэн байх болно.'
            text3='Үүдэл эсийг зөвхөн төрөлтийн үед авах боломжтой тул энэ нь амьдралдаа ганцхан удаа тохиох чухал боломж юм.'
            attachText='Танд зориулсан үйлчилгээний дэлгэрэнгүй танилцуулгыг доорх холбоосоор татаж авна уу.'
            bonus=''
            ccEmail='bank@cellclinic.mn'
          />
        </div>
       <div
                className='h-full p-20 flex flex-col items-center justify-center rounded-xl 
            mobile:mt-5 mobile:mb-5 mobile:max-w-full mobile:p-0 mobile:px-5  
            maxScreen:p-0 extraScreen:p-0 maxScreen:py-20 extraScreen:py-20  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'
              >
                <main className='flex flex-col justify-center'>
                  <div
                    className='bg-cover bg-center bg-no-repeat flex flex-row justify-between items-center py-5 px-5 rounded-2xl mobile:flex-col mobile:justify-center mobile:items-center '
                    style={{
                      backgroundImage: `url(${carepay})`,
                      mixBlendMode: 'luminosity'
                    }}
                  >
                    <div className='h-20 w-1/5 mobile:w-full ml-5 mobile:ml-40'>
                      <img
                        className='cursor-pointer h-[40px] mt-4'
                        src={logo}
                        alt='logo'
                      ></img>
                    </div>
                    <div className='text-white w-4/5 px-20 text-center text-[24px]  mobile:text-[20px] mobile:mb-2 mobile:px-0 mobile:w-full'>
                      Хүү, шимтгэлгүй хуваан төлөх онцгой нөхцөл
                    </div>
                    <div className='w-[160px] mobile:w-full cursor-pointer mobile:flex  mobile:items-center mobile:flex-col flex justify-end flex-col'>
                      <img
                        className=' mobile:h-[40px]'
                        src={android}
                        alt='dd'
                        onClick={() =>
                          window.open(
                            'https://play.google.com/store/apps/details?id=com.bitsoft.carepay'
                          )
                        }
                      ></img>
                      <img
                        src={apple}
                        alt='ff'
                        className='mt-2 cursor-pointer  mobile:h-[40px]'
                        onClick={() =>
                          window.open(
                            'https://apps.apple.com/mn/app/carepay/id6446045879'
                          )
                        }
                      ></img>
                    </div>
                  </div>
                </main>
              </div>

        <div className=''>
          <p className='text-center text-[#1B4046] text-[32px] mb-10 mobile:p-4 mobile:mb-0 mobile:text-[20px] tablet:text-[24px] uppercase font-inter-bold'>
            Санал болгож буй үүдэл эс хадгалах багцууд
          </p>
        </div>
        <div
          className='backdrop-blur-xl bg-white/10 flex flex-col w-full rounded-xl px-20 
      mobile:p-0 mobile:border-none mobile:px-5  
      tablet:px-5 
       maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto maxScreen:px-0 extraScreen:px-0'
        >
          <ServiceCardNew
            services={filteredServices}
            isTag={false}
            col='grid-cols-3'
            openModal={openModal}
          />
        </div>
        {/* Modal Component */}
        {isModalOpen && (
          <ServiceModal
            selectedService={selectedService}
            closeModal={closeModal}
          />
        )}
        <div className='px-20 mb-20 mobile:px-5 mobile:py-0 mobile:mb-5 tablet:px-5  tablet:py-5 extraScreen:px-0 maxScreen:px-0 maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'>
          <QASectionSub
            tags={[
              { name: 'Ерөнхий ойлголт', category: 'Ерөнхий ойлголт' },
              { name: 'Хүйн цус гэж юу вэ', category: 'Хүйн цус' },
              {
                name: 'Хүйн эдийн мезенхимийн үүдэл эс хадгалалт',
                category: 'Хүйн эд'
              }
            ]}
            textColor='#2D707B'
          />
        </div>
        {/* contact us section */}
        <div className='ml-20 mr-20 mobile:ml-5 mobile:mr-5 tablet:ml-5 tablet:mr-5   maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'>
          <ConnectUs
            bgImage='blue'
            gradientColor='bg-gradient-to-l from-[#89E5D6] to-[#08393C] '
          ></ConnectUs>
        </div>
        {/* footer section */}
        <div className='py-10 px-20 mobile:py-0 tablet:px-5  tablet:mb-5 maxScreen:px-0 extraScreen:px-0  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'>
          <FooterSection></FooterSection>
        </div>
      </div>
    </>
  )
}
